const d = u();
function u() {
  var t;
  return typeof window < "u" && !!((t = window.document) != null && t.createElement);
}
function o(t) {
  return t ? t.ownerDocument || t : document;
}
function g(t) {
  return o(t).defaultView || window;
}
function c(t, n) {
  n === void 0 && (n = !1);
  const {
    activeElement: r
  } = o(t);
  if (!(r != null && r.nodeName))
    return null;
  if (s(r) && r.contentDocument)
    return c(r.contentDocument.body, n);
  if (n) {
    const i = r.getAttribute("aria-activedescendant");
    if (i) {
      const e = o(r).getElementById(i);
      if (e)
        return e;
    }
  }
  return r;
}
function l(t, n) {
  return t === n || t.contains(n);
}
function s(t) {
  return t.tagName === "IFRAME";
}
function w(t) {
  const n = t.tagName.toLowerCase();
  return n === "button" ? !0 : n === "input" && t.type ? f.indexOf(t.type) !== -1 : !1;
}
const f = ["button", "color", "file", "image", "reset", "submit"];
function a(t, n) {
  return "matches" in t ? t.matches(n) : "msMatchesSelector" in t ? t.msMatchesSelector(n) : t.webkitMatchesSelector(n);
}
function h(t) {
  const n = t;
  return n.offsetWidth > 0 || n.offsetHeight > 0 || t.getClientRects().length > 0;
}
function p(t, n) {
  if ("closest" in t) return t.closest(n);
  do {
    if (a(t, n)) return t;
    t = t.parentElement || t.parentNode;
  } while (t !== null && t.nodeType === 1);
  return null;
}
function m(t) {
  try {
    const n = t instanceof HTMLInputElement && t.selectionStart !== null, r = t.tagName === "TEXTAREA";
    return n || r || !1;
  } catch {
    return !1;
  }
}
export {
  d as canUseDOM,
  p as closest,
  l as contains,
  c as getActiveElement,
  o as getDocument,
  g as getWindow,
  w as isButton,
  s as isFrame,
  m as isTextField,
  h as isVisible,
  a as matches
};
//# sourceMappingURL=dom.js.map
